import BaseModel from '../../../../base/base_model';
import _ from '../../../../utils/underscore';
import Device from '../../../../utils/device';
import {ON_DEMAND} from './on_demand_hybrid_consts';
import Store from '../../../../utils/store';


class OnDemandModel extends BaseModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'OnDemandModel';

    _nTimeOut = 0;
    _bEnableChillRemoteLoading = false;

    init(params) {

        if (_.isNullOrUndefined(params)) {
            return;
        }

        if(!_.isNullOrUndefined(params.enableChillRemoteLoading)) {
            this._bEnableChillRemoteLoading = params.enableChillRemoteLoading;
        }

        if (Device.isNativeIOS() || Device.isHybridPokerIos() || Device.isHybridSportIos()) {
            params = params.ios;
        } else if (Device.isNativeAndroid()) {
            params = params.android;
        }

        if (!_.isNullOrUndefined(params) && !_.isNullOrUndefined(params.timeout)) {
            this._nTimeOut = params.timeout;
        }
    }

    /**
     * @get the Function Name
     */
    getFuncName(data) {
        let fn = data[ON_DEMAND.CB_FN];

        return undefined !== fn ? fn : '';
    }

    isEnableChillRemoteLoading() {
        return this._bEnableChillRemoteLoading;
    }

    getTimeOut() {
        return this._nTimeOut;
    }

    saveOnDemandLoadedGame(gameType) {
        Store.set(gameType.toString(), false);
    }

    isOnDemandLoadedGame(gameType) {
        return true;
    }
}

export default OnDemandModel;